import { Link } from "react-router-dom";
import usePwaInstall from "@/lib/usePwaInstall";

/**
 * FooterAppPromo — slot permanente de chamada para instalação do PWA,
 * fixado no Footer global no "buraco" que existe à esquerda da lista
 * vertical de links (Navegar). Em vez de criar mais um banner inferior
 * com moldura/texto/CTA duplicados, este componente usa exclusivamente
 * a **arte original da Peça B do kit de parcerias** — que já tem o
 * iPhone, o título "Leve o Direito Público no Bolso.", o sub-texto e o
 * CTA "[Baixe o App de Estudos]" embutidos no próprio design.
 *
 * O wrapper aplica apenas uma linha fina âmbar (`border-amber-500/50`)
 * para separar a arte do background do footer, e a imagem inteira é
 * clicável, levando à landing `/app`.
 *
 * Auto-oculta quando o usuário já está em modo standalone (PWA
 * instalado) — não faz sentido vender instalação para quem já instalou.
 */
export default function FooterAppPromo() {
  const { isStandalone } = usePwaInstall();
  if (isStandalone) return null;

  const onClick = () => {
    try {
      if (typeof window?.gtag === "function") {
        window.gtag("event", "footer_app_promo_click", {
          event_category: "engagement",
          event_label: "pwa_install_promo_footer",
        });
      }
    } catch { /* noop */ }
  };

  return (
    <Link
      to="/app"
      onClick={onClick}
      aria-label="Leve o Direito Público no Bolso — Baixe o App de Estudos do JurisTube"
      data-testid="footer-app-promo"
      className="block overflow-hidden rounded-xl border border-amber-500/50 hover:border-amber-400 transition-colors"
    >
      {/* Responsive artwork: Peça C (formato quase quadrado, 384×362) é
          desenhada para legibilidade em telas estreitas; Peça B
          (horizontal larga 837×362) é desenhada para o "buraco"
          horizontal no desktop. ``<picture>`` faz o browser baixar
          *apenas* a imagem certa para o viewport, sem desperdício. */}
      <picture>
        <source
          media="(min-width: 768px)"
          srcSet="/brand/parcerias/juristube-parceria-B-hero.png 1x, /brand/parcerias/juristube-parceria-B-hero@2x.png 2x"
        />
        {/* Default (mobile) — Peça B-square (quadrada, 1:1) com o mesmo
            mockup do iPhone e mesma headline da Peça B horizontal. */}
        <img
          src="/brand/parcerias/juristube-parceria-B-square.png"
          srcSet="/brand/parcerias/juristube-parceria-B-square.png 1x, /brand/parcerias/juristube-parceria-B-square@2x.png 2x"
          alt="Leve o Direito Público no Bolso — Instale o aplicativo do JurisTube e tenha acesso a debates estruturados, citações automáticas em ABNT e monitoramento legislativo diário. Botão: Baixe o App de Estudos."
          width={837}
          height={362}
          loading="lazy"
          decoding="async"
          className="block w-full h-auto"
          data-testid="footer-app-promo-image"
        />
      </picture>
    </Link>
  );
}
